export const ACTIVITY_LABEL_MAP = {
  6: 'Email delivered',
  5: 'Email opened',
  17: 'Email Link Click',
  4: 'Email bounced',
  23: 'Email invalid',
  15: 'Email unsubscribed',
  7: 'SMS sent',
  8: 'SMS delivered',
  24: 'SMS invalid',
  16: 'SMS unsubscribed',
  26: 'SMS link clicked',
  18: 'Survey Opened',
  19: 'Survey completed',
  29: 'Form completed',
  22: 'Page view',
  25: 'Custom view',
  20: 'Job view',
  21: 'Application view',
};

export function makeActivityTriggerItem(activityTrigger, activityId, label) {
  const clone = JSON.parse(JSON.stringify(activityTrigger));
  clone.triggerName = label;
  clone.thirdColumn.activities = [activityId];
  return clone;
}

export function makeActivityConditionItem(activityCondition, activityId, label) {
  const clone = JSON.parse(JSON.stringify(activityCondition));
  clone.ifElseFirstColumnName = label;
  clone.thirdColumn.activities = [activityId];
  return clone;
}

export function findTrigger(triggers, name) {
  return triggers.find(t => t.triggerName && t.triggerName.toLowerCase() === name.toLowerCase()) || null;
}

export function findTriggerById(triggers, id) {
  return triggers.find(t => t.triggerId === id) || null;
}

// Stable sort: live items first, then soon, then request
export function liveFirst(items) {
  const order = { live: 0, soon: 1, request: 2 };
  return [...items].sort((a, b) => (order[a.status] ?? 1) - (order[b.status] ?? 1));
}
